<template>
	<div class="baseplugin" v-if="iseditor" style="width: calc(100% + 10px);">
	  <div v-bar="{preventParentScroll: true}" :style="{height: `${height}px`}"><div>
		<draggable :options="{group: {name: 'sort1',pull: 'clone',put: false},draggable: '.plugin-li',sort: false,ghostClass: 'sortghost'}"
			@start="onStart" @end="onEnd" class="baseplugin-ul">
			<div class="plugin-li" style="border:0;width:0"></div>
			<div class="plugin-li" v-for="(plugin, idx) in plugins" :key="idx" :data-role="plugin.name">
				<i :class="plugin.icon"></i>
				<p>{{plugin.alias}}</p>
			</div>
			<div style="clear: both;height: 0;overflow: hidden;"></div>
		</draggable>
	  </div></div>
	  <div class="tip-left" v-if="pluginTipsShow">
		按住鼠标左键拖动插件到页面
		<span class="tip-close" @click="hidePlugintips">x</span>
	  </div>
	</div>

	<div v-else>
	  <Menu @on-select="fnSwitch" @on-open-change="openChange" :active-name="mactived" theme="light"
		:open-names="activedMenu" :accordion="true" style="background:transparent">
		<template v-for="(menu, idx) in menus">
			<Submenu :name="`super-m${idx}`" v-if="menu.children.length">
			    <template slot="title">
			        <i :class="menu.icon"></i>{{menu.title}}
			    </template>
			    <MenuItem v-for="(submenu, subidx) in menu.children" :name="submenu._src" :key="subidx">
			    	{{submenu.title}}
				</MenuItem>
			</Submenu>
			<MenuItem :name="menu._src" v-else>
	            <i :class="menu.icon"></i>{{menu.title}}
	        </MenuItem>
		</template>
      </Menu>
	</div>
</template>

<script>
import jGlobal from '@/global';
import EventBus from '@/common/events';
import {menus, plugins} from '@/common/sidebar_data';
import draggable from '@/components/vuedraggable/vuedraggable';

export default
{
	name: 'sidebar',
	data (){
		return {
			menus,
			plugins,
			mactived: '',
			activedMenu: [],
			pluginTipsShow: true,
		}
	},
	created (){
		let [mod, act] = jGlobal.getModAct();
		// Set 'actived-menu'
		this.openMenu(`${mod}/${act}`);
		EventBus.$on("sidebar_menuactived", v => this.mactived = v);
		// for '插件提示信息'
		let ishow = this.$cookie.get('wxplugintips');
		this.pluginTipsShow = (ishow == '0') ? false : true
	},
	methods: {
		hidePlugintips (){
			this.pluginTipsShow = false;
			this.$cookie.set('wxplugintips', '0')
		},
		fnSwitch (pname){
			let _prefix = jGlobal.URLPREFIX;
			location.href = _prefix + pname
		},
		openChange (){
			this.$nextTick(() => EventBus.$emit("winresize", 'update'))
		},
		openMenu (mname){
			let curidx = this.menus.findIndex((c, i) => {
				let found = (c.children || []).find(cc => {
					return (cc._src == mname) ? true : false
				});
				return found ? true : false
			});
			if (curidx > -1) this.activedMenu.push(`super-m${curidx}`)
		},
		onStart (e){
			// for 'web页面'
			if ($('#canvas .cstlayer[type="webpage"]').length > 0) {
				this.$Message.error('当前页面已包含「Web页面」插件，无法再添加其他插件');
				return false
			}
			$(e.item).append('<div class="drophint">放这里</div>');
			EventBus.$emit("drag_add_module", e)
		},
		onEnd (e){
			if ($('#canvas .cstlayer[type="webpage"]').length
				|| e.newIndex == e.oldIndex) return false;
			EventBus.$emit("addplugin_bydrag", 'onEnd', e, event)
		},
	},
	props: ['iseditor', 'height'],
	components: {draggable},
}
</script>

<style type="text/css">
li {list-style: none;}
.baseplugin .drophint, .layout_content .drophint {display: none;}
.baseplugin .baseplugin-ul:after{padding-bottom:3px;}
</style>
<style scoped>
.baseplugin-ul {padding: 10px 20px 10px 10px;box-sizing: border-box;}
.baseplugin .plugin-li {border: 1px solid #dddee1;display: inline-block;float: left;text-align: center;box-sizing: border-box;width: 50%;height: 100px;padding: 25px 0 10px;font-size: 12px;background-color: #fff;color: #a1a1a1;cursor: pointer;margin-left: -1px;margin-top: -1px;}
.baseplugin .plugin-li:hover {background-color: #2d8cf0;color: #fff;}
.baseplugin .plugin-li > i {font-size: 30px;font-weight: 400;line-height: 1;}
.baseplugin .plugin-li > p {font-size: 14px;line-height: 30px;}
.tip-left {line-height:20px;display:inline-block;position:absolute;top:15px;left:242px;color:#fff;font-size:12px;background-color:#2d8cf0;width:200px;padding:5px;text-align:center;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;box-shadow:1px 1px 2px #2d8cf0;-o-box-shadow:1px 1px 2px #2d8cf0;-moz-box-shadow:1px 1px 2px #2d8cf0;-webkit-border-shadow:1px 1px 2px #2d8cf0;}
.tip-left:before {content:'';position:absolute;width:0;height:0;border:10px solid;color:transparent;border-right-color:#2d8cf0;left:-20px;}
.tip-close {cursor:pointer;font-size:14px;margin-left:5px;display:inline-block;background-color: #025cbb;width:20px;height:20px;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;}
</style>



// WEBPACK FOOTER //
// sidebar.vue?e2855bea